import './ListerHeader.scss';

import React from 'react';
import { useSelector } from 'react-redux';

import TopBanner from '../Banner/TopBanner/TopBanner';
import ErrorBoundary from '../ErrorBoundary';
import SortBy from '../ListerControls/SortBy/SortBy';
import ListerTitle from './ListerTitle';
import ProductsPerPage from './ProductsPerPage';
import QuickSearchCarousel from './QuickSearch/QuickSearchCarousel';
import SortByDiscount from './SortByDiscount';
import ViewControls from './ViewControls';

const ListerHeader = () => {
	const { isDealsPage, categoryId } = useSelector((state) => state);

	const { IsTVQuickSearchEnabled } = useSelector(
		(state) => state.featureSwitches
	);

	const tvCategoryIds = [107, 108];

	return (
		<header id="lister-header" data-tag-section="lister header">
			<ListerTitle />

			{!isDealsPage && (
				<ErrorBoundary>
					<TopBanner />
				</ErrorBoundary>
			)}

			{!isDealsPage &&
				IsTVQuickSearchEnabled &&
				tvCategoryIds.includes(categoryId) && (
					<ErrorBoundary>
						<QuickSearchCarousel />
					</ErrorBoundary>
				)}

			{/* {!isBrowserIE11() && TrendingBrandsCarouselEnabled && <TrendingBrands />} */}

			<div className="hidden md:block pb-2" data-testid="responsive-header">
				<div className="flex">
					{isDealsPage && (
						<div className="flex-auto">
							<ViewControls />
						</div>
					)}
					<div className="flex items-center">
						<SortBy />
						<SortByDiscount />
					</div>
					<div className="flex-auto flex justify-end items-center">
						<ProductsPerPage />
					</div>
				</div>
			</div>
		</header>
	);
};

export default ListerHeader;
